module.exports = __webpack_public_path__ + "img/bkg_5_500.bd540502.svg";